<template>
  <div class="app-promo">
    <!-- 纯色背景 -->
    <div class="solid-background"></div>

    <!-- 顶部导航栏 - 改为 div -->
    <div 
      class="navbar fixed-nav" 
      :class="{ 
        'navbar-hidden': !showNavbar
      }"
      ref="navbarRef"
    >
      <div class="logo-area">
        <img src="@/assets/logo.svg" alt="Logo" class="logo-img">
        <span>Accessible Translate</span>
      </div>
      <div class="actions">
        <div class="google-play-btn" @click="handleGooglePlayDownload">
          <span>
            <span class="btn-small-label">GET IT ON</span>
            <span class="btn-store-name">Google Play</span>
          </span>
        </div>
      </div>
    </div>

    <!-- 可滚动的内容区域 - 改为 div -->
    <div 
      class="scrollable-content" 
      ref="scrollableContentRef"
      @scroll="handleScroll"
    >
      <!-- 视频列表 - 单个YouTube视频 -->
      <div class="video-list">
        <!-- 单个视频项 -->
        <div class="video-item">
          <div class="video-info">
            <h3 class="video-title">How to Translate Reddit on Android</h3>
            <div class="video-meta"></div>
          </div>
          <div class="video-container youtube-container">
            <!-- YouTube播放器 -->
            <iframe 
              class="youtube-player"
              :src="youtubeSrc"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
              loading="lazy"
              referrerpolicy="strict-origin-when-cross-origin"
            ></iframe>
          </div>
        </div>
      </div>

      <div class="promo-section">
        <div class="promo-card">
          <!-- 装饰性元素 -->
          <div class="promo-decoration">
            <span class="promo-icon">🌍</span>
          </div>
          
          <!-- 主标题 -->
          <h3 class="promo-title">
            Translate Reddit on Android
            <span class="promo-badge">SOLUTION</span>
          </h3>
          
          <!-- 副标题/描述 -->
          <p class="promo-description">
            No translation button on Reddit? Use Accessible Translate for the best translation experience
          </p>
          
          <!-- 建议奖励说明 -->
          <div class="promo-rewards">
            <div class="reward-item">
              <span class="reward-emoji">📱</span>
              <span class="reward-text">Android Device</span>
            </div>
            <div class="reward-arrow">→</div>
            <div class="reward-item highlight">
              <span class="reward-emoji">🌐</span>
              <span class="reward-text">Translate Reddit</span>
            </div>
          </div>
          
          <!-- 倒计时或限时提示 -->
          <div class="promo-timer">
            <span class="timer-label">⏰ Easy Setup · Instant Translation</span>
          </div>
          
          <!-- 进群按钮 -->
          <div class="promo-actions">
            <button class="join-group-btn" @click="handleGooglePlayDownload">
              <span class="btn-content">
                <span class="btn-text">Download Accessible Translate</span>
                <span class="btn-arrow">→</span>
              </span>
            </button>
          </div>
          
          <!-- 信任标识 -->
          <div class="promo-trust">
              <span class="trust-item">✅ Works on Reddit</span>
              <span class="trust-item">✅ 100% Free</span>
              <span class="trust-item">✅ Easy to Use</span>
          </div>
        </div>
      </div>


      <!-- ===== 问答区域 ===== -->
     <div class="qa-section">
        <h3 class="qa-heading">  FAQ  </h3>
        
        <div class="qa-list">
          <!-- 问答项 1 -->
          <div class="qa-item">
            <div class="qa-question">Why isn't there a translation button on Reddit for Android?</div>
            <div class="qa-answer">
              Reddit's official app for Android doesn't have a built-in translation feature, making it difficult to understand content in foreign languages.
            </div>
          </div>
          
          <!-- 问答项 2 -->
          <div class="qa-item">
            <div class="qa-question">How does Accessible Translate help with Reddit translation?</div>
            <div class="qa-answer">
              Accessible Translate provides an overlay translation feature that works across all apps, including Reddit. It detects foreign language content and offers instant translation with just a tap.
            </div>
          </div>
          
          <!-- 问答项 3 -->
          <div class="qa-item">
            <div class="qa-question">Is Accessible Translate free to use?</div>
            <div class="qa-answer">
              Yes, basic translation is permanently free. You can translate Reddit posts and comments without any cost.
            </div>
          </div>

           <div class="qa-item">
            <div class="qa-question">How to set up Accessible Translate for Reddit?</div>
            <div class="qa-answer">
              1. Download and install Accessible Translate from Google Play Store
              2. Enable the necessary permissions
              3. Open Reddit app and start browsing
              4. When you see foreign content, just tap on it to translate
            </div>
          </div>

           <div class="qa-item">
            <div class="qa-question">Which languages are supported?</div>
            <div class="qa-answer">
              Accessible Translate supports over 100 languages, including English, Chinese, Spanish, Arabic, and many more.
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">Does it work with other apps besides Reddit?</div>
         <div class="qa-answer">
  Yes, Accessible Translate works with more than 10 apps including YouTube, X (Twitter), Bilibili, and more. It's a universal translation solution for all your apps.
</div>
          </div>

        </div>
        
        <!-- 更多帮助链接 -->
      
      </div>

      <!-- 页脚 -->
      <div class="app-footer">
        <p>© 2026 Accessible Translate</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'

// YouTube视频ID - 替换为您的竖屏视频ID
const videoId = 'dQw4w9WgXcQ' // 示例视频ID，请替换为实际的竖屏视频ID


const autoplay = ref(1) // 1=自动播放, 0=不自动播放
const mute = ref(1) // 1=静音, 0=有声 (为了自动播放必须静音)

// 构建YouTube嵌入URL
const youtubeSrc = computed(() => {
  return `https://www.youtube.com/embed/${videoId}?autoplay=${autoplay.value}&mute=${mute.value}&loop=1&playlist=${videoId}&rel=0&modestbranding=1&controls=1&color=white&iv_load_policy=3&disablekb=1&fs=1&playsinline=1`
})

// 导航栏显示状态控制
const showNavbar = ref(true)
const lastScrollTop = ref(0)
const scrollThreshold = 5
const scrollableContentRef = ref(null)
const navbarRef = ref(null)
const navbarHeight = ref(80)

// 跳转到常见问题页面


// 滚动处理函数
const handleScroll = () => {
  if (!scrollableContentRef.value) return
  
  const currentScrollTop = scrollableContentRef.value.scrollTop
  const scrollingDown = currentScrollTop > lastScrollTop.value
  const scrollDifference = Math.abs(currentScrollTop - lastScrollTop.value)
  
  // 添加弹性区域判断，避免在顶部附近频繁切换
  const isNearTop = currentScrollTop < 20
  
  if (scrollDifference > scrollThreshold && !isNearTop) {
    if (scrollingDown && currentScrollTop > 20) {
      // 向下滚动，隐藏导航栏
      if (showNavbar.value) {
        showNavbar.value = false
      }
    } else if (!scrollingDown) {
      // 向上滚动，显示导航栏
      if (!showNavbar.value) {
        showNavbar.value = true
      }
    }
  }
  
  // 如果在顶部，强制显示导航栏
  if (currentScrollTop <= 5 && !showNavbar.value) {
    showNavbar.value = true
  }
  
  lastScrollTop.value = currentScrollTop
}

// 节流函数
const throttle = (func, delay) => {
  let lastCall = 0
  return function(...args) {
    const now = Date.now()
    if (now - lastCall >= delay) {
      func.apply(this, args)
      lastCall = now
    }
  }
}

// Google Play 下载处理
const handleGooglePlayDownload = () => {
  window.open('https://play.google.com/store/apps/details?id=com.floating.manager1', '_blank')
}

// 更新导航栏高度
const updateNavbarHeight = () => {
  if (navbarRef.value) {
    const height = navbarRef.value.offsetHeight
    navbarHeight.value = height
    document.documentElement.style.setProperty('--navbar-height', height + 'px')
  }
}

onMounted(() => {
  // 初始化导航栏高度
  updateNavbarHeight()
  
  // 监听滚动
  const throttledHandleScroll = throttle(handleScroll, 50)
  if (scrollableContentRef.value) {
    scrollableContentRef.value.addEventListener('scroll', throttledHandleScroll, { passive: true })
  }
  
  // 监听窗口大小变化
  window.addEventListener('resize', updateNavbarHeight)
  
  // 使用 MutationObserver 监听导航栏内容变化
  const observer = new MutationObserver(updateNavbarHeight)
  if (navbarRef.value) {
    observer.observe(navbarRef.value, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    })
  }
  
  return () => {
    if (scrollableContentRef.value) {
      scrollableContentRef.value.removeEventListener('scroll', throttledHandleScroll)
    }
    window.removeEventListener('resize', updateNavbarHeight)
    observer.disconnect()
  }
})
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: #f8f9fa;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  width: 100%;
  height: 100%;
  display: block;
}
.email-highlight {
  color: #0066cc;           /* 蓝色文字 */
  font-weight: 600;         /* 加粗 */
  background-color: #f0f7ff; /* 浅蓝色背景 */
  padding: 2px 6px;         /* 内边距 */
  border-radius: 4px;       /* 圆角 */
  text-decoration: none;    /* 无下划线 */
  transition: all 0.3s ease; /* 平滑过渡 */
}

:root {
  --navbar-height: 80px;
  --green-primary: #7ad663;      /* 绿色主色调 */
  --green-dark: #479215;          /* 深绿色 */
  --green-gradient: linear-gradient(90deg, #7ad663, #479215);
}

/* Font Awesome 图标库引入 */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');
</style>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app-promo {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  position: relative;
  background: #f8f9fa;
  color: #1e293b;
  overflow: hidden;
}
.promo-section {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 20px 30px 20px;
  background: linear-gradient(180deg, transparent 0%, rgba(122, 214, 99, 0.05) 100%);
}

.promo-card {
  max-width: 720px;
  width: 100%;
  background: linear-gradient(135deg, #ffffff 0%, #f9fff5 100%);
  border-radius: 32px;
  padding: 32px 24px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(71, 146, 21, 0.15), 0 0 0 1px rgba(122, 214, 99, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* 装饰性背景元素 */
.promo-card::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at top right, rgba(122, 214, 99, 0.1), transparent 50%);
  z-index: 0;
  pointer-events: none;
}

.promo-decoration {
  text-align: center;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
}

.promo-icon {
  font-size: 3.5rem;
  display: inline-block;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.promo-title {
  font-size: 1.8rem;
  font-weight: 800;
  color: #1e293b;
  text-align: center;
  margin-bottom: 12px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.promo-badge {
  background: linear-gradient(135deg, #ff6b6b, #ff4757);
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 30px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.promo-description {
  font-size: 1.2rem;
  color: #334155;
  text-align: center;
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
  line-height: 1.5;
}

.highlight-text {
  font-weight: 700;
  color: #479215;
  background: linear-gradient(120deg, rgba(122, 214, 99, 0.2), transparent);
  padding: 0 8px;
  border-radius: 20px;
  display: inline-block;
}

.promo-rewards {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
  flex-wrap: wrap;
}

.reward-item {
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  padding: 10px 18px;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(122, 214, 99, 0.2);
}

.reward-item.highlight {
  background: linear-gradient(135deg, #7ad663, #479215);
  border-color: transparent;
}

.reward-item.highlight .reward-text {
  color: white;
  font-weight: 600;
}

.reward-emoji {
  font-size: 1.2rem;
}

.reward-text {
  font-size: 0.95rem;
  font-weight: 500;
  color: #1e293b;
}

.reward-arrow {
  font-size: 1.5rem;
  color: #7ad663;
  font-weight: 300;
}

.promo-timer {
  text-align: center;
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
}

.timer-label {
  background: rgba(122, 214, 99, 0.1);
  color: #479215;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 8px 20px;
  border-radius: 50px;
  display: inline-block;
  border: 1px dashed #7ad663;
}

.promo-actions {
  text-align: center;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.join-group-btn {
  background: linear-gradient(135deg, #7ad663, #479215);
  border: none;
  border-radius: 60px;
  padding: 16px 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 25px -5px rgba(71, 146, 21, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-width: 240px;
}

.join-group-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px -5px rgba(71, 146, 21, 0.5);
}

.join-group-btn:active {
  transform: translateY(0);
  box-shadow: 0 5px 15px -5px rgba(71, 146, 21, 0.4);
}

.btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.btn-text {
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.btn-arrow {
  color: white;
  font-size: 1.4rem;
  transition: transform 0.3s ease;
}

.join-group-btn:hover .btn-arrow {
  transform: translateX(5px);
}

.btn-subtext {
  color: #64748b;
  font-size: 0.8rem;
  margin-top: 8px;
}

.promo-trust {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
}

.trust-item {
  color: #475569;
  font-size: 0.85rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 移动端适配 */
@media (max-width: 480px) {
  .promo-section {
    padding: 15px 16px 25px 16px;
  }
  
  .promo-card {
    padding: 24px 16px;
  }
  
  .promo-title {
    font-size: 1.5rem;
    flex-wrap: wrap;
  }
  
  .promo-description {
    font-size: 1rem;
  }
  
  .promo-rewards {
    flex-direction: column;
    gap: 10px;
  }
  
  .reward-arrow {
    transform: rotate(90deg);
  }
  
  .reward-item {
    width: 100%;
    justify-content: center;
  }
  
  .join-group-btn {
    padding: 14px 30px;
    min-width: 200px;
  }
  
  .btn-text {
    font-size: 1rem;
  }
  
  .promo-trust {
    gap: 12px;
  }
  
  .trust-item {
    font-size: 0.75rem;
  }
}

@media (max-width: 360px) {
  .promo-title {
    font-size: 1.3rem;
  }
  
  .promo-badge {
    font-size: 0.6rem;
    padding: 3px 8px;
  }
  
  .promo-icon {
    font-size: 3rem;
  }
}
/* 纯色背景层 */
.solid-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #e2ffbb;
  z-index: 0;
}

/* 顶部导航栏 */
.fixed-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  transition: transform 0.3s cubic-bezier(0.2, 0, 0, 1);
  will-change: transform;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

/* 导航栏隐藏状态 */
.navbar-hidden {
  transform: translateY(-100%);
}

.logo-area {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 700;
  font-size: 1.3rem;
  letter-spacing: -0.5px;
  color: #1e293b;
}

.logo-img {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  object-fit: cover;
  display: inline-block;
}

.actions {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.google-play-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #485e38, #608447);
  border-radius: 40px;
  padding: 0.4rem 1rem 0.4rem 0.8rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 18px -8px rgba(37, 99, 235, 0.3);
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(4px);
  font-weight: 600;
  color: white;
  white-space: nowrap;
}

.google-play-btn:active {
  transform: scale(0.98);
}

.google-play-btn span {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.1;
}

.btn-small-label {
  font-size: 0.55rem;
  opacity: 0.9;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.9);
}

.btn-store-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: white;
}

/* 可滚动的内容区域 */
.scrollable-content {
  overflow-y: auto;
  overflow-x: hidden;
  background: transparent;
  -webkit-overflow-scrolling: touch;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #f9fef2;
  z-index: 0;
  padding-top: var(--navbar-height);
}

/* 视频列表容器 */
.video-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px 0 30px 0;
}

.video-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.video-info {
  width: 100%;
  display: grid;
  place-items: center;
  margin-bottom: 16px;
}

.video-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #03170a;
  line-height: 1.3;
  position: relative;
  display: inline-block;
}

/* 绿色下划线 */
.video-title::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 3px;
  background: var(--green-gradient);
  border-radius: 3px;
}

.video-meta {
  font-size: 0.85rem;
  color: #648b67;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}

/* YouTube视频容器 */
.video-container.youtube-container {
  width: 90%;
  max-width: 380px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  border-radius: 24px;
  background-color: #000;
  box-shadow: 0 20px 40px rgba(122, 214, 99, 0.15);
  border: 2px solid rgba(122, 214, 99, 0.2);
  aspect-ratio: 9 / 16;
  overflow: hidden;
}

.youtube-player {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* ===== 问答区域样式 ===== */
.qa-section {
  width: 100%;
  max-width: 720px;
  margin: 20px auto 30px;
  padding: 0 20px;
}

.qa-heading {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 24px;
  position: relative;
  display: inline-block;
}

/* 绿色下划线装饰 */
.qa-heading::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 40px;
  height: 3px;
  background: var(--green-gradient);
  border-radius: 3px;
}

.qa-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.qa-item {
  background: white;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.02), 0 0 0 1px rgba(122, 214, 99, 0.2);
  transition: all 0.2s ease;
}

.qa-item:hover {
  box-shadow: 0 12px 28px rgba(122, 214, 99, 0.15), 0 0 0 1px rgba(71, 146, 21, 0.3);
}

.qa-question {
  font-weight: 700;
  color: #0f172a;
  font-size: 1.1rem;
  margin-bottom: 12px;
  line-height: 1.4;
}

.qa-answer {
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.4;
  text-align: left; /* 添加这一行，让内部文字左对齐 */
   text-indent: 1.2em; /* 首行缩进2个字符，最常用 */
}
.qa-footer {
  margin-top: 30px;
  text-align: center;
}

.more-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #479215;
  font-weight: 600;
  text-decoration: none;
  padding: 10px 24px;
  border-radius: 40px;
  background: rgba(122, 214, 99, 0.08);
  transition: all 0.2s;
}

.more-link:hover {
  background: rgba(122, 214, 99, 0.15);
}

/* 移动端优化 - 问答区域 */
@media (max-width: 480px) {
  .qa-section {
    padding: 0 16px;
    margin: 15px auto 25px;
  }
  
  .qa-heading {
    font-size: 1.3rem;
    margin-bottom: 20px;
  }
  
  .qa-heading::after {
    width: 50px;
    bottom: -6px;
  }
  
  .qa-question {
    font-size: 1rem;
    margin-bottom: 10px;
  }
  
  .qa-answer {
    font-size: 0.9rem;
  }
  
  .qa-item {
    padding: 16px;
  }
}

@media (max-width: 360px) {
  .qa-question {
    font-size: 0.95rem;
  }
  
  .qa-answer {
    font-size: 0.85rem;
  }
}
/* ===== 问答区域结束 ===== */

/* 页脚 */
.app-footer {
  text-align: center;
  padding: 1.5rem 1rem 2.5rem 1rem;
  font-size: 0.75rem;
  opacity: 0.6;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  color: #64748b;
  margin-top: 10px;
}

/* 移动端优化 */
@media (max-width: 480px) {
  .navbar {
    padding: 0.7rem 1rem;
  }
  
  .logo-area span {
    font-size: 1.1rem;
  }
  
  .logo-img {
    width: 20px;
    height: 20px;
  }
  
  .actions {
    gap: 0.5rem;
  }
  
  .google-play-btn {
    padding: 0.3rem 0.8rem 0.3rem 0.6rem;
  }
  
  .btn-store-name {
    font-size: 0.8rem;
  }
  
  .video-list {
    padding: 15px 0 20px 0;
  }
  
  .video-container.youtube-container {
    width: 92%;
    max-width: 340px;
  }
  
  .app-footer {
    padding: 1rem 0.5rem 2rem 0.5rem;
  }
}

@media (max-width: 360px) {
  .navbar {
    padding: 0.6rem 0.8rem;
  }
  
  .logo-area span {
    font-size: 1rem;
  }
  
  .logo-img {
    width: 18px;
    height: 18px;
  }
  
  .video-container.youtube-container {
    width: 95%;
    max-width: 300px;
  }
  
  .video-title {
    font-size: 1rem;
  }
}

button, 
.google-play-btn {
  min-height: 44px;
}

/* 安全区域适配 */
@supports (padding: max(0px)) {
  .navbar {
    padding-left: max(1.5rem, env(safe-area-inset-left));
    padding-right: max(1.5rem, env(safe-area-inset-right));
    padding-top: max(1rem, env(safe-area-inset-top));
  }
  
  .scrollable-content {
    padding-left: max(1rem, env(safe-area-inset-left));
    padding-right: max(1rem, env(safe-area-inset-right));
  }
  
  .app-footer {
    padding-bottom: max(2rem, env(safe-area-inset-bottom));
  }
}

.scrollable-content::-webkit-scrollbar {
  width: 4px;
}

.scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
</style>